import { useEffect, useState } from 'react';
import { useSourceOptions } from '@app/queries/options/useSourceOptions';
import { useTagOptions } from '@app/queries/options/useTagOptions';
import { useManagerOptions } from '@app/queries/options/useManagerOptions';
import { ISelectOption } from '@widgets/multi-select';

const DEFAULT_LIST: ISelectOption[] = [];

function useCustomerOptions(): [boolean, ISelectOption[], ISelectOption[], ISelectOption[]] {
  const sourceFilterOptions = useSourceOptions();
  const tagFilterOptions = useTagOptions();
  const managerFilterOptionsFetcher = useManagerOptions();

  const [sourceOptions, setSourceOptions] = useState<ISelectOption[]>(DEFAULT_LIST);
  const [managerOptions, setManagerOptions] = useState<ISelectOption[]>(DEFAULT_LIST);
  const [tagOptions, setTagOptions] = useState<ISelectOption[]>(DEFAULT_LIST);

  useEffect(() => {
    (async () => {
      const data = await sourceFilterOptions.fetchData();
      setSourceOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await managerFilterOptionsFetcher.fetchData();
      setManagerOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await tagFilterOptions.fetchData();
      setTagOptions(data);
    })();
  }, []);

  const loading = !(
    managerFilterOptionsFetcher.isSuccess &&
    tagFilterOptions.isSuccess &&
    sourceFilterOptions.isSuccess
  );

  return [loading, sourceOptions, managerOptions, tagOptions];
}

export default useCustomerOptions;
